import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ElEmpty } from 'element-plus'


export default /*@__PURE__*/_defineComponent({
  __name: 'CandidateEmpty',
  props: {
    description: { default: '暂无数据' },
    imageSize: { default: 120 },
    size: { default: 'medium' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElEmpty), _mergeProps({
    description: _ctx.description,
    "image-size": _ctx.imageSize
  }, _ctx.$attrs), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["description", "image-size"]))
}
}

})